<!-- {{this.anexo.cadArquivoOnline.presignedUrl}} -->
<div [hidden]="((this.cadArquivoOnline$ | async)?.presignedUrl??'')===''">
  <div *ngIf="isImage$ | async">
    <img [src]="this.cadArquivoOnline$?.value?.presignedUrl" />
    <a  target="_blank" [href]="this.cadArquivoOnline$?.value?.presignedUrl"> Baixar: {{this.cadArquivoOnline$?.value?.fileName}}
    </a>
  </div>
  
  <div *ngIf="!(isImage$ | async)">
   
    <a  target="_blank" [href]="this.cadArquivoOnline$?.value?.presignedUrl"> Baixar: {{this.cadArquivoOnline$?.value?.fileName}}
    </a>
  </div>
  <!-- Certifique-se de substituir this.cadArquivoOnline$?.value?.presignedUrl por cadArquivoOnline$.value?.presignedUrl e assim por diante, porque você já está usando o async pipe que lida automaticamente com nulos e indefinidos -->

<!-- Verifique se é possível usar apenas um *ngIf para tratar a condição de imagem ou não imagem -->
<div [hidden]="!cadArquivoOnline$.value?.presignedUrl">
  <div *ngIf="isImage$ | async; else notImage">
    <img [src]="cadArquivoOnline$.value?.presignedUrl" />
    <a target="_blank" [href]="cadArquivoOnline$.value?.presignedUrl"> Baixar: {{cadArquivoOnline$.value?.fileName}}</a>
  </div>
  <ng-template #notImage>
    <a target="_blank" [href]="cadArquivoOnline$.value?.presignedUrl"> Baixar: {{cadArquivoOnline$.value?.fileName}}</a>
  </ng-template>

  <!-- Adicionando a condição do PDF -->
  <div *ngIf="isPdf(cadArquivoOnline$.value?.contentType)">
    <div fxLayout="row wrap" class="m-16" fxLayout.lt-sm="column">
      <div fxLayout="row wrap" fxLayout.lt-sm="column">
        <div fxFlex="100" class="pr-1" fxLayoutAlign="center center">
          <button mat-icon-button (click)="firstPage()" [disabled]="currentPage === 1">
            <mat-icon>first_page</mat-icon>
          </button>
          <button mat-icon-button (click)="previousPage()" [disabled]="currentPage === 1">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <span class="page-indicator">{{currentPage}} / {{totalPages}}</span>
          <button mat-icon-button (click)="nextPage()" [disabled]="currentPage === totalPages">
            <mat-icon>chevron_right</mat-icon>
          </button>
          <button mat-icon-button (click)="lastPage()" [disabled]="currentPage === totalPages">
            <mat-icon>last_page</mat-icon>
          </button>
        </div>
        <div fxFlex="100" class="pr-1">
          <canvas #pdfViewer width="820" height="1000" style="border: 1px solid black;"></canvas>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!cadArquivoOnline$.value?.presignedUrl">
  Nenhuma visualização disponível!
</div>

